<template>
  <div>
    <v-row no-gutters v-if="!isMobile">
      <v-col cols="12">
        <v-row no-gutters>
          <image-row :title="topTitle" config="page-careers" :with_button="true" />
        </v-row>
        <div class="why-mwm-wrapper">
          <div class="why-mwm-content">
            <div class="why-mwm-title-wrapper">
              <v-row no-gutters justify="space-between">
                <v-col cols="6">
                  <div class="why-mwm-title" v-html="whyMwmTitle" />
                  <div class="why-mwm-text" v-html="whyMwmText1" />
                </v-col>
                <v-col cols="6">
                  <v-img eager class="why-mwm-logo" max-height="350" contain src="https://storage.googleapis.com/mwm-website-v2-content/career/phones.png" />
                </v-col>
              </v-row>
            </div>
            <div class="figures-wrapper">
              <v-row no-gutters>
                <v-col cols="4" v-for="figure in figures" :key="figure.key">
                  <div class="figures-title" v-html="figure.title" />
                  <div class="figures-text" v-html="figure.text" />
                </v-col>
              </v-row>
            </div>
            <div class="random-wrapper">
              <div class="why-mwm-text" v-html="whyMwmText2" />
            </div>
            <div class="scroll-to-offers-wrapper">
              <v-btn height="54" :ripple="false" @click="$vuetify.goTo(target, options)" class="scroll-to-offers-button">
                <span class="scroll-to-offers-text">{{ scrollToOffersText }}</span>
              </v-btn>
            </div>
            <div class="environment-wrapper">
              <v-row no-gutters justify="space-around">
                <v-spacer />
                <v-col cols="3">
                  <v-img eager class="environment-quoter-image" height="220" contain src="https://storage.googleapis.com/mwm-website-v2-content/career/picture-jbh.png" />
                </v-col>
                <v-col cols="7">
                  <div class="environment-quote-text-parent">
                    <span class="environment-quote environment-quote-text-child">{{ environmentQuote }}</span>
                    <span class="environment-quoter environment-quote-text-child">{{ environmentQuoter }}</span>
                    <img class="environment-quotemark-topleft" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                    <img class="environment-quotemark-botright" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                  </div>
                </v-col>
                <v-spacer />
              </v-row>
            </div>
          </div>
        </div>
        <div class="values-wrapper">
          <div class="values-content">
            <div class="values-title-wrapper">
              <div class="values-title" v-html="valuesTitle" />
            </div>
            <div class="values-value-wrapper" v-for="value in values" :key="value.key" >
              <div class="values-value-title" v-html="value.title" />
              <div class="values-value-text" v-html="value.text" />
            </div>
          </div>
        </div>
        <div class="our-work-wrapper">
          <div class="our-work-content">
            <div class="our-work-title-wrapper">
              <div class="our-work-title" v-html="ourWorkTitle" />
              <div class="our-work-text" v-html="ourWorkText" />
            </div>
            <div class="our-work-videos-wrapper">
              <div class="our-work-video-wrapper">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/XEQ4etNN56k" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              <v-row no-gutters align="center" justify="space-around">
                <v-col cols="4">
                  <div class="our-work-video-wrapper">
                    <iframe src="https://www.youtube.com/embed/oXUaTR4Q3cA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="our-work-video-wrapper">
                    <iframe src="https://www.youtube.com/embed/LTP7GSy80Kc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="our-work-video-wrapper">
                    <iframe src="https://www.youtube.com/embed/wHNq5mG04PQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters align="center" justify="space-around">
                <v-col cols="5">
                  <div class="our-work-video-wrapper">
                    <iframe src="https://www.youtube.com/embed/ZzdDs8K9QoI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </v-col>
                <v-col cols="5">
                  <div class="our-work-video-wrapper">
                    <iframe src="https://www.youtube.com/embed/x9WmaEcdjPQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div class="engagement-wrapper">
          <div class="engagement-content">
            <div class="engagement-title-wrapper">
              <div class="engagement-title" v-html="engagementTitle" />
            </div>
            <div class="engagement-item-wrapper">
              <v-row no-gutters align="center" justify="space-around">
                <v-col cols="auto">
                  <v-img @click="openEpic" eager contain src="https://storage.googleapis.com/mwm-website-v2-content/career/engagement-epic.png" />
                </v-col>
                <v-col cols="6">
                  <div class="engagement-text" v-html="engagementEpicText" />
                </v-col>
              </v-row>
            </div>
            <div class="engagement-item-wrapper">
              <v-row no-gutters align="center" justify="space-around">
                <v-col cols="6">
                  <div class="engagement-text" v-html="engagementPouceText" />
                </v-col>
                <v-col cols="auto">
                  <v-img @click="openPouce" eager contain src="https://storage.googleapis.com/mwm-website-v2-content/career/engagement-pouce.png" />
                </v-col>
              </v-row>
            </div>
            <div class="engagement-item-wrapper">
              <v-row no-gutters align="center" justify="space-around">
                <v-col cols="auto">
                  <v-img @click="openEducation" eager contain src="https://storage.googleapis.com/mwm-website-v2-content/career/education-for-madagascar.png" />
                </v-col>
                <v-col cols="6">
                  <div class="engagement-text" v-html="engagementEducationText" />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div class="offices-wrapper">
          <div class="offices-content">
            <div class="offices-title-wrapper">
              <div class="offices-title" v-html="officesTitle" />
              <!-- <div class="offices-text" v-html="officesText" /> -->
            </div>
            <div class="offices-figures-wrapper">
              <v-row no-gutters>
                <v-col cols="4" v-for="figure in officeFigures" :key="figure.key">
                  <div class="offices-figures-title" v-html="figure.title" />
                  <div class="offices-figures-text" v-html="figure.text" />
                </v-col>
              </v-row>
            </div>
            <div class="offices-item-wrapper">
              <v-row no-gutters align="center" justify="space-around">
                <v-col cols="auto">
                  <v-img eager contain src="https://storage.googleapis.com/mwm-website-v2-content/career/offices-2.png" />
                </v-col>
                <v-col cols="6">
                  <div class="offices-item-title" v-html="officesParisTitle" />
                  <div class="offices-item-text" v-html="officesParisText" />
                  <div class="offices-item-btn">
                    <v-btn @click="openParis" outlined class="blue--text text-darken-2">{{officesBtnText}}</v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="offices-item-wrapper">
              <v-row no-gutters align="center" justify="space-around">
                <v-col cols="6">
                  <div class="offices-item-title" v-html="officesBdxTitle" />
                  <div class="offices-item-text" v-html="officesBdxText" />
                  <div class="offices-item-btn">
                    <v-btn @click="openBdx" outlined class="blue--text text-darken-2">{{officesBtnText}}</v-btn>
                  </div>
                </v-col>
                <v-col cols="auto">
                  <v-img eager contain src="https://storage.googleapis.com/mwm-website-v2-content/career/offices-1.png" />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div class="place-wrapper">
          <div class="place-content">
            <div class="place-title-wrapper">
              <div class="place-title" v-html="placeTitle" />
            </div>
            <div class="place-item-wrapper">
              <v-row no-gutters align="center" justify="space-around">
                <v-col cols="auto">
                  <v-img eager contain src="https://storage.googleapis.com/mwm-website-v2-content/career/great-place-to-work.png" />
                </v-col>
                <v-col cols="6">
                  <div class="place-item-text" v-html="placeText" />
                </v-col>
              </v-row>
            </div>
            <div class="place-item-wrapper">
              <v-row no-gutters align="center" justify="space-around">
                <v-col v-for="card in placeCards" :key="card.key" cols="4" class="my-4">
                  <v-hover v-slot="{ hover }" class="mx-4">
                    <v-card min-height="350" :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }">
                      <v-row no-gutters align="center" justify="space-around">
                        <v-img eager contain class="futur-logo" :src="'https://storage.googleapis.com/mwm-website-v2-content/career/' + card.icon" />
                      </v-row>
                      <v-row no-gutters justify="center">
                        <div class="ml-2 place-cards-item-title" v-html="card.title" />
                      </v-row>
                      <v-row no-gutters align="center" justify="space-around">
                        <div :class="hover ? 'mx-2 place-cards-item-text on-hover' : 'mx-2 place-cards-item-text'" v-html="card.text" />
                      </v-row>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div class="hire-wrapper">
          <div class="hire-content">
            <div class="hire-title-wrapper">
              <div class="hire-title" v-html="hireTitle" />
            </div>
            <div class="hire-item-wrapper">
              <v-row no-gutters align="center" justify="left">
                <v-col cols="6">
                  <div class="hire-item-text" v-html="hireText" />
                </v-col>
                <v-spacer />
                <v-col cols="auto">
                  <v-img eager contain src="https://storage.googleapis.com/mwm-website-v2-content/career/hire.png" />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div id="offers" class="jobs-wrapper">
          <div class="jobs-content">
            <div class="jobs-title-wrapper">
              <span class="jobs-title">{{ jobsTitle }}</span>
            </div>
            <div class="job-cards-wrapper">
              <div v-for="category in jobs" :key="category.title">
                <div class="job-cards-category-wrapper">
                  <div class="job-cards-category">
                    <span>{{ category.title }}</span>
                  </div>
                </div>
                <div class="job-card" v-for="job in category.postings" :key="job.id" @click="openUrl(job.hostedUrl)">
                  <v-row no-gutters>
                    <v-col>
                      <span class="job-card-title">{{ job.text }}</span><br />
                      <span class="job-card-text">{{ job.categories.location }}</span>
                      <span v-if="job.categories.department" class="job-card-text mx-1">-</span>
                      <span v-if="job.categories.department" class="job-card-text">{{ job.categories.department }}</span>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn class="jobs-card-btn" :ripple="false" @click="openUrl(job.applyUrl)">
                        <span class="">APPLY</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
                <v-divider class="my-5 white" />
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-else no-gutters>
      <v-col cols="12">
        <v-row no-gutters>
          <image-row :title="topTitle" config="page-careers" :with_button="true" />
        </v-row>
        <div class="why-mwm-wrapper">
          <div class="why-mwm-content">
            <div class="why-mwm-title-wrapper">
              <v-row no-gutters justify="space-between">
                <v-col cols="12">
                  <div class="why-mwm-title" v-html="whyMwmTitle" />
                  <div class="why-mwm-text" v-html="whyMwmText1" />
                </v-col>
              </v-row>
            </div>
            <div class="figures-wrapper">
              <v-row no-gutters>
                <v-col cols="12" v-for="figure in figures" :key="figure.key">
                  <div class="figures-title mt-4" v-html="figure.title" />
                  <div class="figures-text" v-html="figure.text" />
                </v-col>
              </v-row>
            </div>
            <div class="random-wrapper">
              <div class="why-mwm-text" v-html="whyMwmText2" />
            </div>
            <div class="scroll-to-offers-wrapper">
              <v-btn height="54" :ripple="false" @click="$vuetify.goTo(target, options)" class="scroll-to-offers-button">
                <span class="scroll-to-offers-text">{{ scrollToOffersText }}</span>
              </v-btn>
            </div>
            <!-- <div class="environment-wrapper">
              <v-row no-gutters justify="space-around">
                <v-spacer />
                <v-col cols="3">
                  <v-img eager class="environment-quoter-image" height="220" contain src="https://storage.googleapis.com/mwm-website-v2-content/career/picture-jbh.png" />
                </v-col>
                <v-col cols="7">
                  <div class="environment-quote-text-parent">
                    <span class="environment-quote environment-quote-text-child">{{ environmentQuote }}</span>
                    <span class="environment-quoter environment-quote-text-child">{{ environmentQuoter }}</span>
                    <img class="environment-quotemark-topleft" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                    <img class="environment-quotemark-botright" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                  </div>
                </v-col>
                <v-spacer />
              </v-row>
            </div> -->
          </div>
        </div>
        <div class="values-wrapper">
          <div class="values-content">
            <div class="values-title-wrapper">
              <div class="values-title" v-html="valuesTitle" />
            </div>
            <div class="values-value-wrapper" v-for="value in values" :key="value.key" >
              <div class="values-value-title" v-html="value.title" />
              <div class="values-value-text" v-html="value.text" />
            </div>
          </div>
        </div>
        <div class="our-work-wrapper">
          <div class="our-work-content">
            <div class="our-work-title-wrapper">
              <div class="our-work-title" v-html="ourWorkTitle" />
              <div class="our-work-text" v-html="ourWorkText" />
            </div>
            <div class="our-work-videos-wrapper">
              <div class="our-work-video-wrapper">
                <iframe src="https://www.youtube.com/embed/XEQ4etNN56k" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              <v-row no-gutters align="center" justify="space-around">
                <v-col cols="12">
                  <div class="our-work-video-wrapper">
                    <iframe src="https://www.youtube.com/embed/oXUaTR4Q3cA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="our-work-video-wrapper">
                    <iframe src="https://www.youtube.com/embed/LTP7GSy80Kc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="our-work-video-wrapper">
                    <iframe src="https://www.youtube.com/embed/wHNq5mG04PQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="our-work-video-wrapper">
                    <iframe src="https://www.youtube.com/embed/ZzdDs8K9QoI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="our-work-video-wrapper">
                    <iframe src="https://www.youtube.com/embed/ZzdDs8K9QoI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div class="engagement-wrapper">
          <div class="engagement-content">
            <div class="engagement-title-wrapper">
              <div class="engagement-title" v-html="engagementTitle" />
            </div>
            <div class="engagement-item-wrapper">
              <v-row no-gutters align="center" justify="space-around">
                <v-col cols="12">
                  <v-img @click="openEpic" eager contain src="https://storage.googleapis.com/mwm-website-v2-content/career/engagement-epic.png" />
                </v-col>
                <v-col cols="12">
                  <div class="engagement-text" v-html="engagementEpicText" />
                </v-col>
              </v-row>
            </div>
            <div class="engagement-item-wrapper">
              <v-row no-gutters align="center" justify="space-around">
                <v-col cols="12">
                  <v-img @click="openPouce" eager contain src="https://storage.googleapis.com/mwm-website-v2-content/career/engagement-pouce.png" />
                </v-col>
                <v-col cols="12">
                  <div class="engagement-text" v-html="engagementPouceText" />
                </v-col>
              </v-row>
            </div>
            <div class="engagement-item-wrapper">
              <v-row no-gutters align="center" justify="space-around">
                <v-col cols="12">
                  <v-img @click="openEducation" eager contain src="https://storage.googleapis.com/mwm-website-v2-content/career/education-for-madagascar.png" />
                </v-col>
                <v-col cols="12">
                  <div class="engagement-text" v-html="engagementEducationText" />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div id="offers" class="jobs-wrapper">
          <div class="jobs-content">
            <div class="jobs-title-wrapper">
              <span class="jobs-title">{{ jobsTitle }}</span>
            </div>
            <div class="job-cards-wrapper">
              <div v-for="category in jobs" :key="category.title">
                <div class="job-cards-category-wrapper">
                  <div class="job-cards-category">
                    <span>{{ category.title }}</span>
                  </div>
                </div>
                <div class="job-card" v-for="job in category.postings" :key="job.id" @click="openUrl(job.hostedUrl)">
                  <v-row no-gutters>
                    <v-col>
                      <span class="job-card-title">{{ job.text }}</span><br />
                      <span class="job-card-text">{{ job.categories.location }}</span>
                      <span v-if="job.categories.department" class="job-card-text mx-1">-</span>
                      <span v-if="job.categories.department" class="job-card-text">{{ job.categories.department }}</span>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn class="jobs-card-btn" :ripple="false" @click="openUrl(job.applyUrl)">
                        <span class="">APPLY</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
                <v-divider class="my-5 white" />
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- <v-row v-else no-gutters>
      <v-col cols="12">


        <v-row no-gutters justify="center">
          <div class="champion-logos-wrapper">
            <v-row class="mb-5" no-gutters justify="space-around">
              <v-col cols="5" align="center" class="champion-logos-card">
                <img class="champion-logo" :src="championLogos[0].src" />
                <div class="champion-logo-text-wrapper">
                  <span class="champion-logo-text" v-html="championLogos[0].text" />
                </div>
              </v-col>
              <v-col cols="5" align="center" class="champion-logos-card">
                <img class="champion-logo" :src="championLogos[1].src" />
                <div class="champion-logo-text-wrapper">
                  <span class="champion-logo-text" v-html="championLogos[1].text" />
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-5" no-gutters justify="space-around">
              <v-col cols="5" align="center" class="champion-logos-card">
                <img class="champion-logo" :src="championLogos[2].src" />
                <div class="champion-logo-text-wrapper">
                  <span class="champion-logo-text" v-html="championLogos[2].text" />
                </div>
              </v-col>
              <v-col cols="5" align="center" class="champion-logos-card">
                <img class="champion-logo" :src="championLogos[3].src" />
                <div class="champion-logo-text-wrapper">
                  <span class="champion-logo-text" v-html="championLogos[3].text" />
                </div>
              </v-col>
            </v-row>
          </div>
        </v-row>
        <v-row no-gutters justify="center">
          <v-col cols="10" align="center">
            <div class="champion-actor-wrapper">
              <span class="champion-actor">{{ championActorText }}</span>
            </div>
            <div class="champion-ecosystem-wrapper">
              <span class="champion-ecosystem">{{ championEcosystemText }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center" class="labels-logos-wrapper">
          <img class="labels-logo" src="https://storage.googleapis.com/mwm-website-v2-content/logo-frenchtech.png" />
          <img class="labels-logo" src="https://storage.googleapis.com/mwm-website-v2-content/logo-bpi-france.png" />
          <img class="labels-logo" src="https://storage.googleapis.com/mwm-website-v2-content/logo-francedigitale.png" />
        </v-row>
        <v-row no-gutters justify="center" class="environment-bg-mobile">
          <v-col cols="10" align="center">
            <div class="environment-title-wrapper">
              <span class="environment-title">{{ environmentTitle }}</span>
            </div>
            <v-img eager class="environment-quoter-image" height="160" contain src="https://storage.googleapis.com/mwm-website-v2-content/career/picture-jbh.png" />
            <v-row no-gutters>
              <img height="25" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg">
            </v-row>
            <div class="environment-quote">{{ environmentQuote }}</div>
            <div class="environment-quoter">{{ environmentQuoter }}</div>
            <v-row no-gutters justify="end">
              <img height="25" class="environment-quotemark-mobile-rotated" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg">
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center">
          <div class="environment-logos-wrapper">
            <v-row no-gutters class="environment-logos" justify="space-around">
              <v-col class="my-1" align="center" v-for="logo in environmentLogos" :key="logo.key">
                <v-img eager contain class="environment-logo" :src="logo.src" />
                <div class="environment-logo-text-wrapper">
                  <span class="environment-logo-text" v-html="logo.text" />
                </div>
              </v-col>
            </v-row>
          </div>
        </v-row>
        <v-row no-gutters justify="center">
          <div class="offices-wrapper">
            <div class="offices-content">
              <div class="offices-title-wrapper">
                <span class="offices-title" v-html="officesTitle" />
              </div>
              <v-card class="offices-card">
                <img class="offices-card-image" height="250" :src="offices[0].image" >
                <div class="offices-card-title-wrapper">
                  <span class="offices-card-title">{{ offices[0].title }}</span>
                </div>
                <div class="offices-card-viewmore-wrapper" @click="openUrl(offices[0].redirect)">
                  <span class="offices-card-viewmore">{{ officeViewmore }}</span>
                </div>
              </v-card>
              <v-card class="offices-card">
                <img class="offices-card-image" height="250" :src="offices[1].image" >
                <div class="offices-card-title-wrapper">
                  <span class="offices-card-title">{{ offices[1].title }}</span>
                </div>
                <div class="offices-card-viewmore-wrapper" @click="openUrl(offices[1].redirect)">
                  <span class="offices-card-viewmore">{{ officeViewmore }}</span>
                </div>
              </v-card>
            </div>
          </div>
        </v-row>
        <v-row no-gutters justify="center" class="place-patchwork-wrapper">
          <v-col cols="10" align="center">
            <place-image type="gym" text="Free acces to our gym" src="https://storage.googleapis.com/mwm-website-v2-content/career/mosaic_mobile_01.png"/>
            <place-image class="place-image-mobile" type="food" text="Fruit, snacks & drinks" src="https://storage.googleapis.com/mwm-website-v2-content/career/mosaic_mobile_02.png"/>
            <place-image class="place-image-mobile" type="stars" text="Awesome investors" src="https://storage.googleapis.com/mwm-website-v2-content/career/mosaic_mobile_03.png"/>
            <place-image class="place-image-mobile" type="fun" text="Plenty of afterworks & activities" src="https://storage.googleapis.com/mwm-website-v2-content/career/mosaic_mobile_04.png"/>
            <place-image class="place-image-mobile" type="brunch" text="Brunch every month " src="https://storage.googleapis.com/mwm-website-v2-content/career/mosaic_mobile_05.png"/>
            <place-image class="place-image-mobile" type="games" text="Entertainment area" src="https://storage.googleapis.com/mwm-website-v2-content/career/mosaic_mobile_06.png"/>
            <place-image class="place-image-mobile" type="parking" text="Your own parking lot" src="https://storage.googleapis.com/mwm-website-v2-content/career/mosaic_mobile_07.png"/>
            <place-image class="place-image-mobile" type="more_fun" text="Awesome team building activities" src="https://storage.googleapis.com/mwm-website-v2-content/career/mosaic_mobile_08.png"/>
            <place-image class="place-image-mobile" type="beauty" text="Haircut & manicure" src="https://storage.googleapis.com/mwm-website-v2-content/career/mosaic_mobile_09.png"/>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center" class="place-patchwork-wrapper">
          <v-col cols="12" align="center">
            <v-img eager contain class="futur-logo" src="https://storage.googleapis.com/mwm-website-v2-content/career/epic-logo-horizontal.svg" />
            <span class="epic-content-text" v-html="epicText" />
          </v-col>
        </v-row>
        <v-row no-gutters justify="center">
          <div class="jobs-wrapper">
            <div class="jobs-content">
              <div class="jobs-title-wrapper">
                <span class="jobs-title">{{ jobsTitle }}</span>
              </div>
              <div class="job-cards-wrapper">
                <div v-for="category in jobs" :key="category.title">
                  <div class="job-cards-category-wrapper">
                    <div class="job-cards-category">
                      <span>{{ category.title }}</span>
                    </div>
                  </div>
                  <div class="job-card" v-for="job in category.postings" :key="job.id" @click="openUrl(job.hostedUrl)">
                    <v-row no-gutters align="center">
                      <v-col cols="9">
                        <span class="job-card-title">{{ job.text }}</span>
                      </v-col>
                      <v-col cols="3">
                        <v-btn block class="jobs-card-btn" :ripple="false" @click="openUrl(job.applyUrl)">
                          <span class="caption font-weight-bold">APPLY</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-divider class="my-2" />
                    <v-row no-gutters>
                      <v-col cols="12">
                        <span class="job-card-text">{{ job.categories.location }}</span>
                        <span v-if="job.categories.department" class="job-card-text mx-1">-</span>
                        <span v-if="job.categories.department" class="job-card-text">{{ job.categories.department }}</span>
                      </v-col>
                    </v-row>
                  </div>
                  <v-divider class="my-5 white" />
                </div>
              </div>
            </div>
          </div>
        </v-row>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SizeHolder from '@/mixins/SizeHolder.vue';

import ImageRow from './components/ImageRow.vue'

export default {
  mixins: [SizeHolder],
  components: {
    'image-row': ImageRow
  },
  data: () => ({
    topTitle: 'Join our team to become part<br />of our wonderful adventure!',

    whyMwmTitle: 'Why MWM?',
    whyMwmText1: 'Over the years, MWM has become one of the most promising startup of the French Tech ecosystem. Global leader in the creative apps market, <b>MWM registers more than 450 millions downloads</b> worldwide with <b>more than 30 apps</b> covering the main creativity segment such as music, drawing, photo and video.',
    whyMwmText2: 'If you are looking for <b>challenges in your professional life</b>, MWM is the place to be. Here, you will create apps used by millions of users. You will join a <b>team driven by perfection and technical independence</b>. You will have full control of your projects and you will join independent teams to conceive our future hit apps.',

    figures: [
      { key: 'editor', title: '1<sup><small>st</small></sup>', text: '<b>music apps</b><br/>publisher worldwide' },
      { key: 'downloads', title: '450', text: '<b>millions downloads</b><br/>' },
      { key: 'apps', title: '30', text: '<b>apps in music,</b><br/>drawing, photo and video' }
    ],

    scrollToOffersText: '🚀   See job offers!',

    environmentQuote: 'I deeply believe that joining MWM represents a huge career opportunity. We aren’t looking for average. We are looking for excellence and working here means working with a team in perpetual self-questioning to find it!',
    environmentQuoter: 'Jean-Baptiste Hironde, CEO',

    valuesTitle: 'What we believe in.',
    values: [
      { key: 'passion', title: '🔥 Don’t do things. Live Them!', text: 'At MWM, we enjoy doing our job. Each and everyone of us is passionate about our job, about MWM market and more generally about the project. This global passion generates a lot of motivation for all of us, and that’s maybe what got us to go this far?' },
      { key: 'impact', title: '💥 Be focused on impact.', text: 'There is no room for chance: at MWM, we are data-driven and all of our decisions are based on data so that it has meaning and impact. Each choice must have a measurable result and that’s why we are constantly striving to push our limits to do better everyday.' },
      { key: 'learn', title: '💫 Try, Learn and Get Better.', text: 'We consider that failures and bad choices aren’t necessarily negative. No. Because each obstacle is an opportunity to find a better solution and to progress. Bouncing, pivoting and being agile, this is what led us to become a leader in our market and this is our main spearhead!' }
    ],

    ourWorkTitle: '🛰️<br />Come see how we work!',
    ourWorkText: 'We could give you long speeches to explain in detail who we are and how we work… Instead, we prefer to open the doors of the office to you!',

    engagementTitle: '🏫<br />MWM is committed to youth learning.',
    engagementEpicText: 'MWM supports Epic Foundation, a global nonprofit association which backs outstanding nonprofits and social innovation to <b>change the lives of disadvantaged youth</b>.',
    engagementPouceText: 'MWM supports Coup de pouce Humanitaire, which occasionally helps African, Asian and South American associations. MWM has particularly helped build <b>three schools in Ghana, Madagascar and Malawi</b>.',
    engagementEducationText: 'MWM supports the Education for Madagascar initiative, which <b>helps local children get out of poverty</b>.',

    officesTitle: '🏠<br />Discover your next office…',
    // officesText: 't is a long established fact that a reader will be distracted by the readable content.',
    officeFigures: [
      { key: 'offices', title: '2', text: '<b>Offices</b><br/>Paris & Bordeaux' },
      { key: 'people', title: '110', text: '<b>MWMers</b><br/>and many more to come!' },
      { key: 'etages', title: '5', text: '<b>Floors</b><br/>to welcome all these people ' }
    ],
    officesParisTitle: 'Paris',
    officesParisText: '<b>Our HQ is based in Boulogne-Billancourt</b>, near the subway. This is where the huge majority of us work and this is where we organize all our great events : those that gather the whole team!',
    officesBdxTitle: 'Bordeaux',
    officesBdxText: 'Since September 2019, MWM has installed its suitcases <b>in the Gironde capital</b>! You can find us at Les Halles Héméra coworking space, where we now welcome around fifteen MWMers.',
    officesBtnText: 'Learn more',

    // officeViewmore: 'View more',
    // offices: [
    //   { key: 'paris', title: 'in Paris', image: 'https://storage.googleapis.com/mwm-website-v2-content/career/office-paris.jpg', redirect: 'https://www.welcometothejungle.com/fr/companies/mwm/bureaux/paris' },
    //   { key: 'bordeaux', title: 'in Bordeaux', image: 'https://storage.googleapis.com/mwm-website-v2-content/career/office-bdx.jpg', redirect: 'https://www.welcometothejungle.com/fr/companies/mwm/bureaux/bordeaux' },
    // ],

    placeTitle: '🙌<br />A great place to work.',
    placeText: 'We consider success as a whole, and <b>we firmly believe that to work well we have to feel good</b>. We owe the brilliance of our teams to their personal growth. For that matter, MWM has obtained the Happy at Work certification, and is even <b>ranked among the 40 Best Startups to work in France</b>!',
    placeCards: [
      { key: 'profit', icon: 'place-profit.png', title: 'Profit-sharing', text: 'Every year, you will receive your well-earned share for the good job you accomplished the previous year!' },
      { key: 'saving', icon: 'place-savings.png', title: 'Company Saving Plans', text: 'Company Savings and Retirement plans are available  to each MWMer so that they can serenely prepare for their future.' },
      { key: 'swile', icon: 'place-swile.png', title: 'Swile Card', text: 'No more restaurant tickets! MWM provides each employee with a Swile card, allowing them to benefit from dematerialized meal vouchers!' },
      { key: 'gym', icon: 'place-gym.png', title: 'MWM Gym', text: 'Keeping fit is definitely the best way to go! Fitness addicts will be more than happy to learn that MWM has a 100% free 120m2 gym!' },
      { key: 'hairdresser', icon: 'place-hairdresser.png', title: 'Well-Being Services', text: 'Every month, MWM provides free hairdressers, manicurists and osteopaths who come on site ro provide their services.' },
      { key: 'snacks', icon: 'place-snacks.png', title: 'Snack & Drinks', text: 'Drinks and snacks are available to all employees: enough to organize a snack or a refreshing break in summer!' }
    ],

    hireTitle: '🤝<br />How we hire.',
    hireText: 'It is part of our values: each MWMer must do things with passion and resilience. That’s why our recruitment process focuses on <b>both technical and soft skills</b>. And to make sure both sides are eager to collaborate, we make a point of making you meet the key people you will work with.',

    jobsTitle: 'Jobs',
    joinButtonText: 'View job offers',
    jobsUrl: 'https://www.welcometothejungle.com/fr/companies/mwm/jobs',
  }),
  methods: {
    goto (route) {
      this.$router.push(route);
    },
    openEpic () {
      this.openUrl('https://epic.foundation/')
    },
    openPouce () {
      this.openUrl('https://www.cdepouce.com/')
    },
    openEducation () {
      this.openUrl('https://www.educationformadagascar.com/fr/accueil.html')
    },
    openParis () {
      this.openUrl('https://www.welcometothejungle.com/fr/companies/mwm/bureaux/paris')
    },
    openBdx () {
      this.openUrl('https://www.welcometothejungle.com/fr/companies/mwm/bureaux/bordeaux')
    },
    openUrl (url) {
      const win = window.open(url, '_blank');
      win.focus();
    }
  },
  computed: {
    ...mapGetters([
      'jobs',
    ]),
    target () {
      return '#offers'
    },
    options () {
      return {
        duration: 300,
        offset: 0,
        easing: 'easeInOutCubic',
      }
    },
  },
  mounted () {
    this.$store.dispatch('fetchJobs');
  }
};
</script>

<style scoped lang="scss">
@media (max-width: 1280px) {
  .job-cards-wrapper {
    width: 90%!important;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 960px) {
  .epic-wrapper {
    width: 90%!important;
  }

  .why-mwm-title-wrapper {
    margin-top: 2rem!important;
    text-align: left!important;
    width: 100%!important;
    margin-left: auto;
    margin-right: auto;
  }

  .why-mwm-title {
    font-size: 45px!important;
  }

  .why-mwm-text {
    font-size: 15px!important;
  }

  .figures-wrapper {
    margin-top: 0rem!important;
  }

  .scroll-to-offers-wrapper {
    margin-top: 2rem!important;
  }

  .values-title-wrapper {
    margin-top: 6rem;
    margin-left: auto;
    margin-right: auto;
    width: 55%;
  }

  .values-title {
    font-size: 35px!important;
  }

  .values-value-wrapper {
    margin-top: 3rem!important;
    width: 80%!important;
  }

  .values-value-title {
    font-size: 25px!important;
    line-height: normal!important;
  }

  .values-value-text {
    font-size: 14px!important;
  }

  .our-work-wrapper {
    padding-top: 4rem!important;
  }

  .our-work-title-wrapper {
    width: 85%!important;
  }

  .our-work-title {
    font-size: 45px!important;
    line-height: normal!important;
  }

  .our-work-text {
    padding-top: 1rem!important;
  }

  .our-work-videos-wrapper {
    width: 100%!important;
  }

  .our-work-video-wrapper {
    margin-bottom: 2rem!important;
  }

  .engagement-wrapper {
    display: table;
    width: 100%;
    height: 90vh;
    margin-right: auto;
    margin-left: auto;
    background-color: #f4f5f5;
  }

  .engagement-title-wrapper {
    margin-top: 4rem!important;
    width: 80%!important;
    margin-left: auto;
    margin-right: auto;
  }

  .engagement-title {
    font-size: 35px!important;
  }

  .engagement-item-wrapper {
    width: 70%!important;
  }

  .engagement-text {
    font-size: 16px!important;
  }

  .labels-logo {
    height: 57px!important;
  }

  .labels-logos-wrapper {
    margin-top: 3rem!important;
    margin-bottom: 3rem!important;
  }

  .environment-bg-mobile {
    background-color: #f4f5f5!important;
    padding-bottom: 4rem!important;
  }

  .environment-title-wrapper {
    margin-top: 4rem;
    width: 80%!important;
  }

  .environment-title {
    font-size: 24px!important;
  }

  .environment-quote {
    position: unset!important;
    font-size: 15px!important;
    margin-top: 1rem;
  }

  .environment-quoter {
    position: unset!important;
    font-size: 15px!important;
    margin-top: 1rem;
  }

  .environment-quotemark-mobile {

  }

  .environment-quotemark-mobile-rotated {
    transform: rotate(180deg);
  }

  .environment-logos-wrapper {
    margin-top: 2rem!important;
    margin-bottom: 4rem!important;
    width: 80%!important;
  }

  .environment-logo {
    max-width: 100px!important;
  }

  .environment-logo-text {
    font-size: 14px!important;
  }

  .offices-title-wrapper {
    margin-top: 4rem!important;
    margin-bottom: 4rem!important;
  }

  .offices-card {
    margin-bottom: 6rem!important;
  }

  .offices-title {
    font-size: 26px!important;
  }

  .offices-card {
    margin-top: 2rem!important;
  }

  .offices-card-image {
    width: 100%!important;
    height: auto!important;
  }

  .place-patchwork-wrapper {
    margin-top: 6rem!important;
    width: 80%!important;
  }

  .place-image-mobile {
    margin-top: 4rem!important;
  }

  .futur-logo {
    width: 60%!important;
    margin: auto!important;
    padding-bottom: 3rem;
  }

  .epic-content-text {
    font-size: 16px!important;
  }

  .jobs-wrapper {
    margin-top: 4rem;
  }

  .job-cards-wrapper {
    width: 90%!important;
    margin-left: auto;
    margin-right: auto;
  }

  .job-card {
    padding: 0.5rem!important;
  }

  .job-card-title {
    font-size: 16px!important;
  }

  .job-card-text {
    font-size: 12px!important;
  }

  .jobs-card-btn {
    width: 4rem!important;
  }

  .job-cards-category {
    font-size: 16px!important;
  }
}

.why-mwm-wrapper {
  display: table;
  width: 55%;
  height: 80vh;
  margin-right: auto;
  margin-left: auto;
  background-color: #ffffff;
}

.why-mwm-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.why-mwm-title-wrapper {
  margin-top: 4rem;
  text-align: left;
}

.why-mwm-title {
  font-family: CenturyGothic;
  font-size: 65px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #0b142a;
  text-align: left;
}

.why-mwm-text {
  padding-top: 1rem;
  font-family: CenturyGothic;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  line-height: 35px;
  letter-spacing: normal;
  text-align: center;
  color: #0b142a;
  text-align: left;
}

.figures-wrapper {
  margin-top: 4rem;
}

.figures-title {
  font-family: CenturyGothic;
  font-size: 100px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #8510B3;
}

.figures-text {
  font-family: CenturyGothic;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #8510B3;
}

.random-wrapper {
  margin-top: 4rem;
}

.random-text {
  padding-top: 1rem;
  font-family: CenturyGothic;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  line-height: 35px;
  letter-spacing: normal;
  text-align: center;
  color: #0b142a;
  text-align: left;
}

.scroll-to-offers-wrapper {
  margin-top: 4rem;
}

.scroll-to-offers-button {
  margin: 1.2rem;
  width: 200px;
  text-transform: unset;
  border-radius: 27px;
  position: relative;
  background-color: #ffffff!important;
  z-index: 1;
}

.scroll-to-offers-text {
  font-family: CenturyGothic;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
}

.environment-wrapper {
  margin-top: 4rem;
  margin-bottom: 8rem;
}

.environment-title-wrapper {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}

.environment-title {
  font-family: CenturyGothic;
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  color: #212a39;
}

.environment-quote-wrapper {
  margin-top: 4rem;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
}

.environment-quoter-image {
  margin-top: 2rem;
}

.environment-quote-text-parent {
  position: relative;
}

.environment-quote-text-child {
  position: absolute;
}

.environment-quote {
  position: absolute;
  left: 2rem;
  top: 4rem;
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: italic;
  text-align: justify;
  line-height: 1.6;
  letter-spacing: normal;
  color: #212a39;
}

.environment-quoter {
  position: absolute;
  left: 2rem;
  top: 17rem;
  font-family: CenturyGothic;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: italic;
  line-height: normal;
  letter-spacing: normal;
  color: #212a39;
}

.environment-quotemark-topleft {
  position: absolute;
  left: 0;
}

.environment-quotemark-botright {
  position: absolute;
  transform: rotate(180deg);
  right: -2rem;
  top: 13.5rem;
}

.environment-logos-wrapper {
  margin-top: 6rem;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
}

.environment-logos {

}

.environment-logo {

}

.environment-logo-text-wrapper {

}

.environment-logo-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #212a39;
}

.values-wrapper {
  display: table;
  width: 100%;
  height: 60vh;
  padding-bottom: 8rem;
  margin-right: auto;
  margin-left: auto;
  background-image: -webkit-gradient(linear, left bottom, right top, color-stop(108%, #8e0eb3), color-stop(13%, #0e25a9));
  background-image: linear-gradient(to bottom left, #8e0eb3, #0e25a9);
}

.values-content {
  display: table-cell;
  vertical-align: middle;
}

.values-title-wrapper {
  margin-top: 6rem;
  margin-left: auto;
  margin-right: auto;
  width: 55%;
}

.values-title {
  font-family: CenturyGothic;
  font-size: 65px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}

.values-value-wrapper {
  margin-top: 6rem;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.values-value-title {
  font-family: CenturyGothic;
  font-size: 55px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 66px;
  letter-spacing: normal;
  color: #ffffff;
}

.values-value-text {
  padding-top: 1rem;
  font-family: CenturyGothic;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 35px;
  letter-spacing: normal;
  color: #ffffff;
}

.our-work-wrapper {
  padding-top: 6rem;
  display: table;
  width: 100%;
  height: 90vh;
  margin-right: auto;
  margin-left: auto;
  background-color: #ffffff;
}

.our-work-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.our-work-title-wrapper {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}

.our-work-title {
  font-family: CenturyGothic;
  font-size: 65px;
  font-weight: bold;
  text-align: left;
  color: #212a39;
}

.our-work-text {
  font-family: CenturyGothic;
  font-size: 18px;
  font-weight: normal;
  text-align: left;
  color: #212a39;
}

.our-work-videos-wrapper {
  margin-top: 4rem;
  width: 75%;
  margin-left: auto;
  margin-right: auto;
}

.our-work-video-wrapper {
  margin-bottom: 2rem;
}

// ---------------------------------------

.engagement-wrapper {
  display: table;
  width: 100%;
  height: 90vh;
  margin-right: auto;
  margin-left: auto;
  background-color: #f4f5f5;
}

.engagement-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.engagement-title-wrapper {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}

.engagement-title {
  font-family: CenturyGothic;
  font-size: 65px;
  font-weight: bold;
  text-align: left;
  color: #212a39;
}

.engagement-item-wrapper {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}

.engagement-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: normal;
  text-align: left;
  line-height: 1.7;
  color: #212a39;
}

// ---------------------------------------

.offices-wrapper {
  padding-top: 6rem;
  display: table;
  width: 100%;
  height: 90vh;
  margin-right: auto;
  margin-left: auto;
  background-color: #ffffff;
}

.offices-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.offices-title-wrapper {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}

.offices-title {
  font-family: CenturyGothic;
  font-size: 65px;
  font-weight: bold;
  text-align: left;
  color: #212a39;
}

.offices-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  color: #212a39;
}

.offices-figures-wrapper {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem;
  margin-bottom: 4rem;
}

.offices-figures-title {
  font-family: CenturyGothic;
  font-size: 100px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #00796B;
}

.offices-figures-text {
  font-family: CenturyGothic;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #00796B;
}

.offices-item-wrapper {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

.offices-item-title {
  font-family: CenturyGothic;
  font-size: 50px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}

.offices-item-text {
  padding-top: 1rem;
  font-family: CenturyGothic;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  line-height: 1.6;
}

.offices-item-btn {
  padding-top: 2rem;
}

// ---------------------------------------

.place-wrapper {
  display: table;
  width: 100%;
  height: 90vh;
  margin-right: auto;
  margin-left: auto;
  background-color: #f4f5f5;
}

.place-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.place-title-wrapper {
  padding-top: 4rem;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

.place-title {
  font-family: CenturyGothic;
  font-size: 65px;
  font-weight: bold;
  text-align: left;
  color: #212a39;
}

.place-item-wrapper {
  width: 75%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4rem;
  margin-bottom: 4rem;
  text-align: left;
}

.place-item-text {
  padding-top: 1rem;
  font-family: CenturyGothic;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  line-height: 1.6;
}

.v-card {
  border-radius: 20px!important;
  transform: scale(1.02);
  transition: transform .2s ease-in-out;
}

.v-card:not(.on-hover) {
  transform: scale(1.0);
}

.place-cards-item-title {
  font-family: CenturyGothic;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
}

.place-cards-item-text {
  padding-top: 2rem;
  font-family: CenturyGothic;
  font-size: 15px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
}

.place-cards-item-text:not(.on-hover) {
  transform: opacity(0.3);
}

.place-cards-item-text .on-hover {
  transform: opacity(1.0);
  transition: transform .2s ease-in-out;
}


// .v-card {
//   transform: scale(1.02);
//   transition: transform .2s ease-in-out;
// }
//
// .v-card:not(.on-hover) {
//   transform: scale(1.0);
// }

// ---------------------------------------

.hire-wrapper {
  display: table;
  width: 100%;
  height: 90vh;
  margin-right: auto;
  margin-left: auto;
  background-color: #ffffff;
}

.hire-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  padding-bottom: 6rem;
}

.hire-title-wrapper {
  padding-top: 4rem;
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}

.hire-title {
  font-family: CenturyGothic;
  font-size: 65px;
  font-weight: bold;
  text-align: left;
  color: #212a39;
}

.hire-item-wrapper {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}

.hire-item-text {
  font-family: CenturyGothic;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
}

// ---------------------------------------

.jobs-wrapper {
  display: table;
  width: 100%;
  height: 30vh;
  margin-right: auto;
  margin-left: auto;
  padding-top: 2rem;
  background-image: -webkit-gradient(linear, left top, right bottom, color-stop(34%, #ff7854), color-stop(109%, #ff0067));
  background-image: linear-gradient(to right, #ff7854 34%, #ff0067 109%);
}

.jobs-content {
  display: table-cell;
  vertical-align: middle;
}

.jobs-title-wrapper {
  margin-top: 2rem;
  text-align: center;
}

.jobs-title {
  font-family: CenturyGothic;
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.jobs-button-wrapper {
  margin-top: 1.5rem;
  text-align: center;
}

.jobs-button {
  width: 200px;
  height: 54px;
  border-radius: 27px;
  background-color: #ffffff;
  text-transform: unset;
  box-shadow: unset;
}

.jobs-button-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ec6663;
}

.job-cards-wrapper {
  margin-top: 2rem;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

.job-card {
  margin-top: 1rem;
  padding: 1rem;
  // height: 6rem;
  border-radius: 6px;
  background-color: #ffffff;
  text-transform: unset;
  box-shadow: unset;
  cursor: pointer;
}

.job-card-title {
  font-family: CenturyGothic;
  font-size: 24px;
}

.job-card-text {
  font-family: CenturyGothic;
  font-size: 14px;
  font-weight: bold;
  color: #808080;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.jobs-card-btn {
  background-image: -webkit-gradient(linear, left top, right bottom, color-stop(34%, #ff7854), color-stop(109%, #ff0067));
  background-image: linear-gradient(to right, #ff7854 34%, #ff0067 109%);
  color: #fff!important;
  font-weight: bold;
  height: 1.9rem!important;
  width: 7rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 1.33;
}

.job-cards-category-wrapper {

}

.job-cards-category {
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1px;
  text-transform: uppercase;
}

// .jobs-card-wrapper {
//   width: 50%;
//   margin: auto;
//   background-color: white;
//   margin-top: 6rem;
// }
//
// .jobs-card {
//   height: 606px;
//   width: 50%;
//   margin: auto;
//   border-radius: 26px!important;
// }
</style>
